import { render, staticRenderFns } from "./partnerButton.vue?vue&type=template&id=75f28b21&scoped=true&"
import script from "./partnerButton.vue?vue&type=script&lang=ts&"
export * from "./partnerButton.vue?vue&type=script&lang=ts&"
import style0 from "./partnerButton.vue?vue&type=style&index=0&id=75f28b21&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75f28b21",
  null
  
)

export default component.exports